import classNames from 'classnames'

export function FormattedContent({
  children,
  className,
}: {
  children?: string
  className?: string
}) {
  if (!children) return null
  return (
    <div
      className={classNames('formatted-content pb-3 sm:pb-5', className)}
      dangerouslySetInnerHTML={{ __html: children }}
    />
  )
}
